import axios from 'axios';

const getNoMoreShowings = async (listingId: string): Promise<boolean> => {
  const { data: noMoreShowings } = await axios.get(
    `/listing/${listingId}/appointments/config/noMoreShowings`,
  );

  return noMoreShowings;
};

export default getNoMoreShowings;
